<template>
  <AllegroJsonForm
    title="Edytuj sprzedawcę Allegro"
    crumbLabel="Edycja sprzedawcy"
    :settingsCrumb="true"
    submitAction="updateAllegroSeller"
    submitGetter="getAllegroSellerUpdateData"
    loadAction="getAllegroSeller"
    loadGetter="getAllegroSellerData"
    :isUpdate="true"
    backRoute="/allegro/accounts"
    :modelPermission="modelPermission"
    :fields="fields"
  />
</template>

<script>
import AllegroJsonForm from "./AllegroJsonForm.vue";
import { allegroSellerPermissionsConst } from "../../constants/allegroConstants";

export default {
  name: "AllegroSellerUpdate",
  components: { AllegroJsonForm },
  data() {
    return {
      modelPermission: allegroSellerPermissionsConst.update,
      fields: [
        { key: "tax_id", label: "NIP", required: true },
        { key: "company_name", label: "Nazwa firmy", required: true },
        { key: "first_name", label: "Imię", required: true },
        { key: "last_name", label: "Nazwisko", required: true },
        { key: "street", label: "Ulica", required: true },
        { key: "zip_code", label: "Kod pocztowy", required: true },
        { key: "city", label: "Miejscowość", required: true },
        { key: "logo", label: "Logo", type: "file" },
      ],
    };
  },
};
</script>
